import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from './firebase';

export class SimpleCodeValidation {
  static async validateStudentCode(code: string): Promise<{
    isValid: boolean;
    studentData?: any;
    source?: string;
    error?: string;
  }> {
    try {
      const upperCode = code.trim().toUpperCase();

      const linkingCodeDocument = await getDoc(doc(db, 'linkingCodes', upperCode));
      if (linkingCodeDocument.exists()) {
        const linkingCodeData = linkingCodeDocument.data();
        if (
          linkingCodeData.userType === 'student' &&
          linkingCodeData.isActive !== false
        ) {
          const userDocument = await getDoc(
            doc(db, 'users', linkingCodeData.userId)
          );
          if (userDocument.exists()) {
            return {
              isValid: true,
              studentData: { id: userDocument.id, ...userDocument.data() },
              source: 'linkingCodes + users',
            };
          }
        }
      }

      const usersQuery = query(
        collection(db, 'users'),
        where('role', '==', 'student'),
        where('linkingCode', '==', upperCode)
      );
      const usersSnapshot = await getDocs(usersQuery);
      if (!usersSnapshot.empty) {
        const userDocument = usersSnapshot.docs[0];
        return {
          isValid: true,
          studentData: { id: userDocument.id, ...userDocument.data() },
          source: 'users',
        };
      }

      return {
        isValid: false,
        error: 'الكود غير موجود في النظام',
      };
    } catch (error) {
      console.error('Error validating student code:', error);
      return {
        isValid: false,
        error: 'خطأ في التحقق من الكود',
      };
    }
  }
}

export default SimpleCodeValidation;
